import { render, staticRenderFns } from "./GreenCityBatchDetail.vue?vue&type=template&id=ae86ac5e&scoped=true&"
import script from "./GreenCityBatchDetail.vue?vue&type=script&lang=js&"
export * from "./GreenCityBatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./GreenCityBatchDetail.vue?vue&type=style&index=0&id=ae86ac5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae86ac5e",
  null
  
)

export default component.exports